import React, { Component, Fragment } from 'react'
import { SingleDatePicker } from 'react-dates'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import moment from 'moment'

import 'react-dates/initialize'
// import 'react-dates/lib/css/_datepicker.css'
import TargetDateIcon from '../../../static/images/icons/icon-target_date.svg'
import CheckmarkIcon from '../../../static/images/icons/asset_checkmark.svg'
import colors from '../../../configuration/colors'

import { hideModal } from '../../../actions/_modal'
import ModalFullScreen from '../../mini/ModalFullScreen'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import LoadingSpinner from '../../mini/LoadingSpinner'
import CloseModal from '../../styled/CloseModal'
import {
  fetchUserQuestAssessments
} from './API.js'
import {
  Container,
  ModalTop,
  CancelButton,
  SaveButton,
  Header,
  ButtonBlock,
  HeaderBlock,
  ModalQuestBlock,
  QuestImage,
  QuestHeader,
  ModalArtifactBlock,
  CalendarBlock,
  ApplyToAll,
  Checkbox,
  CheckboxBlock,
  CheckboxIcon
} from './_Styled'
import ArtifactDescription from '../../Activities/ArtifactDescription'
import {
  actionMyStudentsCreateTargetDate,
  actionMyStudentsUpdateTargetDate
} from '../../../actions/mystudents'
import { LexiconContext } from '../../../contexts/Lexicon'

const StyledDatePickerWrapper = styled.div`
  & .SingleDatePicker,
  .SingleDatePickerInput {
    .DateInput_input{
      text-align: center;
    }
    .SingleDatePickerInput__withBorder {
       padding: 1px;
        font-family: 'Lato', sans-serif;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
        border-radius: 5px;
        background-color: #FFFFFF;
        margin-right: 20px;
    .CalendarDay__default:hover {
      background: #FFAE00;
    }
      .CalendarDay__selected {
        background: #FFAE00;
      }
    }
    .DateInput_fang{
      display: none
    }
    .DayPickerKeyboardShortcuts_buttonReset {
      display: none
    }
    .DayPicker__withBorder{
      box-shadow: none
      border: 0.5px solid ${colors.ash};
    }
    .DayPicker_transitionContainer{
      width: 615px !important
    }
    .DateInput_input__disabled{
      background: ${colors.white} !important;
    }
  }
`

export class UpdateTargetDate extends Component {
  constructor (props) {
    super(props)

    this.state = {
      fetching: false,
      activities: [],
      targetDate: props.targetDate,
      applyToAll: false
    }

    this._fetchUserQuestAssessments = fetchUserQuestAssessments.bind(this)
    this.closeTheModalBound = this.closeTheModal.bind(this)
  }

  static contextType = LexiconContext

  async componentDidMount () {
    this.setState(() => ({
      fetching: true
    }))

    await this._fetchUserQuestAssessments()

    this.setState(() => ({
      fetching: false,
      isClosing: false
    }))
  }

  componentDidUpdate () {
    window.onpopstate = () => {
      this.props.dispatch(hideModal())
    }
  }

  async onSaveTargetDate () {
    const {
      dispatch,
      quest,
      studentId,
      courseSectionId
    } = this.props

    if (this.props.targetDate) {
      dispatch(actionMyStudentsUpdateTargetDate(this.props.targetDate.id, quest.id, quest.level_id, studentId, courseSectionId, this.state.targetDate.target_on, this.state.applyToAll))
    } else {
      dispatch(actionMyStudentsCreateTargetDate(quest.id, quest.level_id, studentId, courseSectionId, this.state.targetDate.target_on, this.state.applyToAll))
    }
  }

  onApplyToAllChange () {
    this.setState(() => ({
      applyToAll: !this.state.applyToAll
    }))
  }

  onDateChange (date) {
    if (date) {
      this.setState(() => ({
        targetDate: {
          ...this.state.targetDate,
          ...{target_on: date.format('YYYY-MM-DD')}
        }
      }))
    } else {
      this.setState(() => ({
        targetDate: null
      }))
    }
  }

  render () {
    const {lexicon} = this.context
    return (
      <ModalFullScreen
        className='journey-status-update-target-date'
        padding={'50px 0 0'}
        allowEscape
        closeCallback={this.closeTheModalBound}
        isClosing={this.state.isClosing}
        backgroundColor='rgba(36, 54, 70, 0.4)'
        allowCloseOnExternalClick
        bodyStyles={{ width: 'fit-content' }}
      >
        <CloseModal
          size={21}
          onClick={this.closeTheModalBound}
          offWhiteIcon
        />
        <Container
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          {this.state.fetching ? (
            <div style={{ minHeight: '300px' }}>
              <LoadingSpinner />
            </div>
          ): (
            <React.Fragment>
              <ModalTop>
                <FlexAlignCenter
                  style={{
                    position: 'relative',
                    width: '100%',
                    justifyContent: 'space-between'
                  }}
                >
                  <HeaderBlock>
                    <img src={TargetDateIcon}/>
                    <Header>Set Target-Date</Header>
                  </HeaderBlock>

                  <ButtonBlock>
                    <CancelButton onClick={this.closeTheModalBound}>Cancel</CancelButton>
                    <SaveButton disabled={!this.state.targetDate} onClick={this.onSaveTargetDate.bind(this)} >Save</SaveButton>
                  </ButtonBlock>
                </FlexAlignCenter>
              </ModalTop>
              <ModalQuestBlock>
                <QuestImage src={this.props.quest.icon_image_url}/>
                <QuestHeader>{this.props.quest.name}</QuestHeader>
              </ModalQuestBlock>
              {this.state.activities.map(activity => <Fragment key={activity.id}>
                <ModalArtifactBlock>
                  <ArtifactDescription
                    artifactDescription={activity.artifact_description}
                    artifactType={activity.artifact_type}
                  />
                </ModalArtifactBlock>
              </Fragment>)}
              <CalendarBlock>
                <HeaderBlock>
                  <StyledDatePickerWrapper>
                    <SingleDatePicker
                      date={this.state.targetDate && moment(this.state.targetDate.target_on, 'YYYY-MM-DD')} // momentPropTypes.momentObj or null
                      onDateChange={this.onDateChange.bind(this)}
                      focused={true} // PropTypes.bool
                      onFocusChange={({ focused }) => this.setState({ focused })}
                      numberOfMonths={2}
                      displayFormat={'DD MMM YYYY'}
                      placeholder={'- -  - - -  - - - -'}
                      disabled={!this.state.targetDate}
                      readOnly
                    />
                  </StyledDatePickerWrapper>
                  <CheckboxBlock onClick={this.onApplyToAllChange.bind(this)}>
                    <Checkbox style={{ background: this.state.applyToAll ? colors.amber : colors.white, borderColor: this.state.applyToAll ? colors.amber : colors.rock }}/>
                    <CheckboxIcon className={'apply-to-all-checkbox'} style={{ opacity: this.state.applyToAll ? '1' : '0' }} src={CheckmarkIcon}/>
                  </CheckboxBlock>
                  <ApplyToAll>Apply to all students in this {lexicon.journey.toLowerCase()} {lexicon.section.toLowerCase()}.</ApplyToAll>
                </HeaderBlock>
              </CalendarBlock>

            </React.Fragment>
          )}
        </Container>
      </ModalFullScreen>
    )
  }

  closeTheModal () {
    const { dispatch } = this.props
    this.setState({
      isClosing: true
    })

    setTimeout(() => {
      dispatch(hideModal())
    }, 500)
  }
}

UpdateTargetDate.propTypes = {
  dispatch: PropTypes.func.isRequired,
  orgId: PropTypes.number.isRequired,
  quest: PropTypes.object.isRequired,
  studentId: PropTypes.number.isRequired,
  token: PropTypes.string.isRequired,
  courseSectionId: PropTypes.number.isRequired,
  targetDate: PropTypes.object
}

export const mapStateToProps = state => ({
  orgId: state.organization.orgId,
  token: state.auth.token
})

export default connect(mapStateToProps)(UpdateTargetDate)
